import { render, staticRenderFns } from "./talk-bridge.vue?vue&type=template&id=135b5c33"
import script from "./talk-bridge.vue?vue&type=script&lang=js"
export * from "./talk-bridge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports